import { render, staticRenderFns } from "./AirlineForm.vue?vue&type=template&id=5023a0d4&"
import script from "./AirlineForm.vue?vue&type=script&lang=js&"
export * from "./AirlineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports